// theme.ts or theme/index.ts
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      purple: "#7C3AED",
      cyan: "#0DD3CD",
      blue: "#3B82F6",
      black: "#111827",
      white: "#FFFFFF",
    },
  },
  fonts: {
    mono: `'Overpass Mono', monospace;`, // 设置自定义字体
    heading: "'Inter', sans-serif",
    body: "'Inter', sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: "white",
        color: "brand.black",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "600",
        borderRadius: "md",
      },
      variants: {
        primary: {
          bg: "brand.purple",
          color: "white",
          _hover: {
            bg: "purple.600",
          },
        },
        secondary: {
          bg: "brand.cyan",
          color: "white",
          _hover: {
            bg: "teal.500",
          },
        },
        accent: {
          bg: "brand.blue",
          color: "white",
          _hover: {
            bg: "blue.600",
          },
        },
        outline: {
          borderColor: "brand.purple",
          color: "brand.purple",
          _hover: {
            bg: "purple.50",
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: "700",
        color: "brand.black",
      },
    },
    Link: {
      baseStyle: {
        color: "brand.blue",
        _hover: {
          textDecoration: "none",
          color: "brand.purple",
        },
      },
    },
  },
});

export default theme;